import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { BffService } from '../../services/BffService';
import { UserType } from '../../models/AuthUser';
import { CorrelationService } from '../../services/correlation.service';
import { UserActionType } from '../../models/correlation.model';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatDividerModule,
    MatCardModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    FormsModule,
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css',
})
export class LoginComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  @Input() email: string = '';
  @Input() password: string = '';

  isLoading = false;
  isAuthenticated = false;
  loginError: string | null = null;

  constructor(
    private bff: BffService,
    private router: Router,
    private correlationService: CorrelationService
  ) {}

  ngOnInit(): void {
    // Generate correlation ID for login page visit
    this.correlationService.startUserAction(UserActionType.VIEW, {
      component: 'LoginComponent',
      page: 'customer-login'
    });

    // Check if user is already authenticated as customer
    // No need to subscribe in BFF mode here; login will redirect
    // Keep page for parity
    /* this.dualAuthService.isAuthenticated$
      .pipe(takeUntil(this.destroy$))
      .subscribe(isAuth => {
        this.isAuthenticated = isAuth;
        if (isAuth && this.dualAuthService.isCustomer()) {
          this.correlationService.logWithCorrelation('User already authenticated (customer), redirecting to customer landing');
          this.router.navigate(['customer/welcome']);
        }
      }); */

    this.correlationService.logWithCorrelation('Customer login component initialized');
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  login(): void {
    // Start correlation tracking for login attempt
    this.correlationService.startUserAction(UserActionType.LOGIN, {
      component: 'LoginComponent',
      userType: 'customer'
    });

    this.isLoading = true;
    this.loginError = null;

    this.correlationService.logWithCorrelation('Customer CIAM login attempt started');

    try {
      this.bff.signInCustomer();
    } catch (error: any) {
      this.correlationService.logWithCorrelation('Customer CIAM redirect login failed', { error: error?.message || error });
      this.isLoading = false;
      this.loginError = 'Login failed. Please try again.';
    }
  }

  loginEmployee(): void {
    // Track employee login action
    this.correlationService.startUserAction(UserActionType.LOGIN, {
      component: 'LoginComponent',
      userType: 'employee'
    });
    try {
      this.bff.signInEmployee();
    } catch (error: any) {
      this.correlationService.logWithCorrelation('Employee redirect login failed', { error: error?.message || error });
    }
  }

  goBack(): void {
    this.router.navigate(['/login']);
  }
}
